import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

/**
 * Recoverable workspace-resolution error.
 *
 * Rendered when a *transient* failure (network blip, PostgREST timeout) breaks
 * the profile/membership lookup — distinct from `denied`, which is a terminal
 * "you don't belong here". A transient failure must NOT strand a legitimate
 * user (e.g. a super_admin) on the terminal denied page, so this page offers a
 * retry instead. Mirrors the recoverable-error pattern in ProtectedRoute
 * (Retry re-runs resolution); a full reload re-drives the resolution effect.
 */
export function WorkspaceErrorPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <AlertTriangle className="h-12 w-12 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Something went wrong</CardTitle>
          <CardDescription>
            We couldn't load this workspace. This is usually a temporary
            connection issue — please try again.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <Button onClick={() => window.location.reload()}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );
}
